import { render, staticRenderFns } from "./reviewer-reports-page.component.vue?vue&type=template&id=fc99e9a4&"
import script from "./reviewer-reports-page.component.ts?vue&type=script&lang=ts&"
export * from "./reviewer-reports-page.component.ts?vue&type=script&lang=ts&"
import style0 from "./reviewer-reports-page.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports